import * as angular from 'angular';

import { ComponentDefinition, Dashboard, AlarmList, Identifier, Group, IValueViewModel, DigitalSetSimpleDictionary, TagStringValueDto, Dictionary, TagDefinition } from '../../models';
import { IWidget } from '../../widgets';

class WidgetSelectorController implements angular.IComponentController {
    dashboards: Dashboard[];
    item: IWidget;

    readonly alarmList: AlarmList;
    readonly digitalSetDictionary: DigitalSetSimpleDictionary;
    readonly groups: Group[];
    readonly identifiers: Identifier[];
    readonly isEditMode: boolean = false;
    readonly isLoaded: boolean;
    readonly ratio: number;
    readonly stringValues: TagStringValueDto[];
    readonly tagsDictionary: Dictionary<TagDefinition>;
    readonly viewModels: Dictionary<IValueViewModel>;

    static $inject = [];
}

export const wtWidgetSelector: ComponentDefinition = {
    componentId: 'wtWidgetSelector',
    controller: WidgetSelectorController,
    template: require('./widgetSelector.component.html'),
    controllerAs: 'vm',
    bindings: {
        alarmList: '<',
        boundMode: '<?',
        connectionPointsDictionary: '<?',
        dashboards: '<',
        digitalSetDictionary: '<?',
        groups: '<?',
        identifiers: '<',
        isEditMode: '<?',
        isLoaded: '<?',
        item: '=',
        ratio: '<?',
        selectedGroup: '<?',
        tagsDictionary: '<?',
        stringValues: '<',
        viewModels: '<?'
    }
};